
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/multilevel/technology",
      function () {
        return require("private-next-pages/alu/multilevel/technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/multilevel/technology"])
      });
    }
  